exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.demi-header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 56px;\n  background-color: white;\n  border-bottom: 1px solid #dfe2eb;\n  z-index: 999;\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/FrontEnd/lili-ui-prod-deploy/src/components/globalUiComponents/userMessage/UserMessage.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,iCAAiC;EACjC,aAAa;CACd","file":"UserMessage.vue","sourcesContent":["\n.demi-header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 56px;\n  background-color: white;\n  border-bottom: 1px solid #dfe2eb;\n  z-index: 999;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-593d462e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/globalUiComponents/userMessage/UserMessage.vue
// module id = F7px
// module chunks = 88